export default __webpack_public_path__ + "static/media/DEFAULT_M.76067d7a.png";